import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/illustrations/illustration-books.svg'
import _imports_1 from '@/modules/profiles/assets/icons/icon-blue-check.svg'


const _withScopeId = n => (_pushScopeId("data-v-17686bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "books",
  class: "header"
}, null, -1))
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Select Languages for", -1))
const _hoisted_4 = { class: "languages" }
const _hoisted_5 = { class: "language-header" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  alt: "blue-check"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Confirm Selection ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    onConfirm: _ctx.confirmLanguages,
    onClose: _ctx.close,
    disabled: _ctx.disableConfirm,
    "main-button-color": "var(--color-confirm)"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("i", null, _toDisplayString(_ctx.selectedSynonym.name), 1)
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
          }, "Select All"),
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deselectAll && _ctx.deselectAll(...args)))
          }, "Deselect All")
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
          return (_openBlock(), _createElementBlock("div", {
            key: language.code,
            class: "each-language",
            onClick: ($event: any) => (_ctx.toggleLanguage(language)),
            style: _normalizeStyle(_ctx.filterLanguages(language) ? {color: "#3897F0"}: "")
          }, [
            _createTextVNode(_toDisplayString(language.name) + " ", 1),
            (_ctx.filterLanguages(language))
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("", true)
          ], 12, _hoisted_6))
        }), 128))
      ])
    ]),
    "button-content": _withCtx(() => [
      _hoisted_8
    ]),
    _: 1
  }, 8, ["onConfirm", "onClose", "disabled"]))
}